<div class="info-strip grid clearfix">
  <div class="info-strip-left grid">
    <button class="back-button" type="button" (click)="back('/rec-date-search')">
      <i class="fa fa-caret-left"></i><p>Back</p>
    </button>
  </div>
  <!--<div class="info-strip-right grid" *ngFor="let r of recs.rec ">-->
  <div class="info-strip-right grid">
    <div class="criteria">
      <h2>Recorded Date Search Results</h2>
      <p>
         <strong>Date:</strong> {{recs.date[0].fromDate| date:'MM-dd-yyyy'}} to {{recs.date[0].toDate| date:'MM-dd-yyyy'}}   <strong>City/Town:</strong> <label *ngIf="towns.length===0">All</label><label *ngIf="towns.length>2">Multiple</label><label *ngIf="towns.length===2">{{towns[0]}},{{towns[1]}}</label>  <strong>Category:</strong> All   <strong>Type:</strong> All   <strong>{{recordCount}}</strong> records found
      </p>
    </div>
  </div>
</div>
